import { render, staticRenderFns } from "./InlinePreviewPlaceholder.vue?vue&type=template&id=74b46041&"
import script from "./InlinePreviewPlaceholder.vue?vue&type=script&lang=js&"
export * from "./InlinePreviewPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports